import util from '@/utils/util';

export function setBtnAreaConfig() {
  return [
    {label: ()=> {return '搜索'}, type: 'primary', bindClick: ()=>{this.getListCX()}, setPower: () => {return true}},
    {label: ()=> {return '重置'}, type: 'primary', bindClick: ()=>{this.resetForm('filters')}, setPower: () => {return true}},
  ]
}
export function setTableConfig() {
	return {
    label: ['Pileline名称', 'Executor实例IP', 'Executor实例名称', 'Submitter实例IP', 'Submitter实例名称', '是否配置FikeSink', 'Submitter操作', 'Executor操作'],
    prop: ['pipelineName', 'ip', 'executorHost', 'submitterIp', 'submitterHost', 'hasFileSink', 'submitterStatus', 'executorStatus'],
    custom: [
      {
        prop: 'hasFileSink',
        width: 140,
        customType: 'custom-dom',
        customRender: (scope) => {
          return `<div>${scope.row.hasFileSink ? '是' : '否'}</div>`
        }
      },
      {
        prop: 'submitterStatus',
        width: 180,
        customType: 'table-btn',
        customBtnList: [
          {
            getStyle: (scope)=> {
              return scope.row.submitterStatus == 0 ? {color: '#787a7f'} : null
            },
            render: (scope) => {
              let { submitId, submitterStatus } = scope.row
              if(submitId && (submitterStatus == 2 || submitterStatus == 0)) {
                return '启动'
              }else {
                return null
              }
            },
            customBindClick: (scope) => {
              let { submitterIp,submitterStatus } = scope.row
              if(submitterStatus == 2) {
                this.startOrStop('Submitter', 1, submitterIp)
              }
            },
          },
          {
            getStyle: (scope)=> {
              return scope.row.submitterStatus == 0 ? {color: '#787a7f'} : null
            },
            render: (scope) => {
              let { submitId, submitterStatus } = scope.row
              if(submitId && (submitterStatus == 1 || submitterStatus == 0)) {
                return '暂停'
              }else {
                return null
              }
            },
            customBindClick: (scope) => {
              let { submitterIp, submitterStatus } = scope.row
              if(submitterStatus == 1) {
                this.startOrStop('Submitter', 2, submitterIp)
              }
            }
          },
          {
            getStyle: (scope)=> {
              return scope.row.submitterStatus == 0 ? {color: '#787a7f'} : null
            },
            render: (scope) => {
              let { submitId } = scope.row
              if(submitId) {
                return '查看状态'
              }else {
                return null
              }
            },
            customBindClick: (scope) => {
              let { submitterStatus } = scope.row
              if(submitterStatus != 0) {
                this.getDetail(scope, 'submitter')
              }
            }
          },
          {
            render: (scope) => {
              if(scope.row.submitId == null) return '--'
            }
          }
        ]
      },
      {
        prop: 'executorStatus',
        customType: 'table-btn',
        width: 180,
        customBtnList: [
          {
            getStyle: (scope)=> {
              return scope.row.executorStatus == 0 ? {color: '#787a7f'} : null
            },
            render: (scope) => {
              let { executorStatus } = scope.row
              if((executorStatus == 2 || executorStatus == 0)) {
                return '启动'
              }
            },
            customBindClick: (scope) => {
              let { ip, executorStatus } = scope.row
              if(executorStatus == 2) {
                this.startOrStop('Executor', 1, ip)
              }
            }
          },
          {
            getStyle: (scope)=> {
              return scope.row.executorStatus == 0 ? {color: '#787a7f'} : null
            },
            render: (scope) => {
              let { executorStatus } = scope.row
              if((executorStatus == 1 || executorStatus == 0)) {
                return '暂停'
              }
            },
            customBindClick: (scope) => {
              let { ip, executorStatus } = scope.row
              if(executorStatus == 1) {
                this.startOrStop('Executor', 2, ip)
              }
            }
          },
          {
            getStyle: (scope)=> {
              return scope.row.executorStatus == 0 ? {color: '#787a7f'} : null
            },
            render: (scope) => {
              let { pipelineId } = scope.row
              if(pipelineId) {
                return '查看状态'
              }else {
                return null
              }
            },
            customBindClick: (scope) => {
              let {executorStatus } = scope.row
              if(executorStatus != 0) {
                this.getDetail(scope, 'executor')
              }
            }
          },
          {
            render: (scope) => {
              if(scope.row.pipelineId == null) return '--'
            }
          }
        ]
      },
    ]
  }
}
